import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { apuntaPantalla } from "@/lib/api/uso";

/**
 * Apunta cada pantalla que se abre. No pinta nada.
 *
 * VA DENTRO DEL `BrowserRouter` Y FUERA DE LAS `Routes`, que es el unico sitio donde ve todos
 * los cambios de direccion: dentro de una ruta solo veria los suyos, y las 48 restantes no se
 * contarian sin que nadie lo notara.
 *
 * NO CUENTA DOS VECES LA MISMA PANTALLA SEGUIDA. React monta y desmonta por su cuenta, y en
 * desarrollo lo hace dos veces a proposito; sin este freno, la mitad de las visitas del
 * informe serian de React y no de nadie. Un cambio de `?buscar=...` tampoco es una pantalla
 * nueva: se mira solo el camino.
 */
export default function CuentaPantallas() {
  const { pathname } = useLocation();
  const ultima = useRef(null);

  useEffect(() => {
    if (!pathname || ultima.current === pathname) return;
    ultima.current = pathname;
    apuntaPantalla(pathname);
  }, [pathname]);

  return null;
}
